<template>
  <div class="confirm-modal-overlay">
    <div class="confirm-modal">
      <div class="confirm-message">{{ message }}</div>
      <div class="confirm-actions">
        <button class="confirm-btn confirm-yes" @click="$emit('confirm')">Yes, delete</button>
        <button class="confirm-btn confirm-cancel" @click="$emit('cancel')">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmDeleteAgent',
  props: {
    message: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/confirm-delete-agent.scss";
</style>
